function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m11.575 6.074c0.2598 0.12489 0.4251 0.38767 0.4251 0.67598v10.5c0 0.2883-0.1653 0.5511-0.4251 0.676-0.2599 0.1249-0.5683 0.0898-0.7934-0.0903l-3.5446-2.8357h-2.7369c-0.41421 0-0.75-0.3358-0.75-0.75v-4.5c0-0.41422 0.33579-0.75 0.75-0.75h2.7369l3.5446-2.8356c0.2251-0.18011 0.5335-0.21522 0.7934-0.09033zm-1.0749 2.2364-2.5315 2.0252c-0.13298 0.1063-0.29822 0.1643-0.46852 0.1643h-2.25v3h2.25c0.1703 0 0.33554 0.058 0.46852 0.1644l2.5315 2.0251v-7.379z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m14.745 8.5c-0.22374 0-0.44667 0.08658-0.61761 0.25753-0.34189 0.34189-0.34189 0.89334 0 1.2352l2.0078 2.0078-2.0078 2.0078c-0.34189 0.34189-0.34189 0.89333 0 1.2352 0.34189 0.34189 0.89333 0.34189 1.2352 0l2.0078-2.0078 2.0078 2.0078c0.34189 0.34189 0.89334 0.34189 1.2352 0 0.34189-0.34189 0.34189-0.89334 0-1.2352l-2.0078-2.0078 2.0078-2.0078c0.34189-0.34189 0.34189-0.89334 0-1.2352-0.34189-0.34189-0.89334-0.34189-1.2352 0l-2.0078 2.0078-2.0078-2.0078c-0.17094-0.17094-0.39387-0.25753-0.61761-0.25753z",
  fill: "white"
});

var SvgIcVolumeOff = function SvgIcVolumeOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcVolumeOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_volume_off.607dbafe.svg";
export { ForwardRef as ReactComponent };